import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "component-tab" }

import { ref, onMounted, nextTick } from 'vue';
import { NCard, NTabs, NTabPane, zhCN, dateZhCN, NConfigProvider } from 'naive-ui';
import themeOverrides from 'config/themeOverrides'
import generalTemplate from '@/components/general-template'
import { useTabs } from '@/composables/useTabs'


export default /*#__PURE__*/_defineComponent({
  props: ['content', 'articleID'],
  setup(__props) {

const props = __props


let { tabs, error } = useTabs(props.content)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    "theme-overrides": _unref(themeOverrides),
    locale: _unref(zhCN),
    "date-locale": _unref(dateZhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(error)), 1),
        (_unref(tabs).data.length)
          ? (_openBlock(), _createBlock(_unref(NTabs), {
              key: 0,
              type: "line",
              animated: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs).data, (tab, index) => {
                  return (_openBlock(), _createBlock(_unref(NTabPane), {
                    name: tab.title,
                    tab: tab.title,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(generalTemplate), {
                        articleID: tab.id,
                        parentID: _unref(props).articleID
                      }, null, 8, ["articleID", "parentID"])
                    ]),
                    _: 2
                  }, 1032, ["name", "tab"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["theme-overrides", "locale", "date-locale"]))
}
}

})